import React from 'react';
import Container from '../../common/Container';
import { Heading, Subheading } from '../../common/TextComponents';
import BentoCard from '../landing/BentoCard';
import { LightBulbIcon, UsersIcon, CubeTransparentIcon } from '@heroicons/react/24/outline';

const BentoIcon = ({ children, className = "" }) => {
  return (
    <div className={`flex items-center justify-center h-12 w-12 rounded-md ${className}`}>
      {children}
    </div>
  );
};

const EmployerValuePropositionSection = ({ isDarkMode = false }) => {
  return (
    <div className={`py-20 md:py-24 ${
      isDarkMode 
        ? 'bg-gradient-to-br from-gray-800 via-gray-900 to-gray-800' 
        : 'bg-gradient-to-br from-gray-50 via-white to-gray-50'
    }`}>
      <Container>
        <div className="text-center mb-16">
          <Subheading dark={isDarkMode}>For Employers</Subheading>
          <Heading as="h2" className="mt-2 mb-6" dark={isDarkMode}>
            Why Burnt?
          </Heading>
          <p className={`mx-auto max-w-3xl text-xl ${
            isDarkMode ? 'text-gray-300' : 'text-gray-600'
          }`}>
            Connect with exceptional talent that brings perspectives you won't find through traditional hiring channels.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
          <BentoCard
            dark={isDarkMode}
            eyebrow={
              <div className="flex items-center mb-3">
                <BentoIcon className={`${
                  isDarkMode 
                    ? 'bg-purple-500/20 text-purple-300 ring-1 ring-purple-500/30' 
                    : 'bg-purple-100 text-purple-600'
                }`}>
                  <UsersIcon className="h-6 w-6" />
                </BentoIcon>
                <span className={`ml-3 font-semibold ${
                  isDarkMode ? 'text-purple-300' : 'text-purple-600'
                }`}>
                  Direct Access
                </span>
              </div>
            }
            title="Connect with vetted professionals seeking new opportunities"
            description="Access a pre-qualified pool of professionals actively seeking their next role, without competing with dozens of recruiters for their attention."
          />

          <BentoCard
            dark={isDarkMode}
            eyebrow={
              <div className="flex items-center mb-3">
                <BentoIcon className={`${
                  isDarkMode 
                    ? 'bg-amber-500/20 text-amber-300 ring-1 ring-amber-500/30' 
                    : 'bg-amber-100 text-amber-600'
                }`}>
                  <LightBulbIcon className="h-6 w-6" />
                </BentoIcon>
                <span className={`ml-3 font-semibold ${
                  isDarkMode ? 'text-amber-300' : 'text-amber-600'
                }`}>
                  Uncover Transferable Genius
                </span>
              </div>
            }
            title="Surface talent with specific high-impact experience"
            description="Discover professionals whose skills and experience cross-pollinate from different industries, bringing fresh approaches and innovative thinking to your team."
          />

          <BentoCard
            dark={isDarkMode}
            eyebrow={
              <div className="flex items-center mb-3">
                <BentoIcon className={`${
                  isDarkMode 
                    ? 'bg-green-500/20 text-green-300 ring-1 ring-green-500/30' 
                    : 'bg-green-100 text-green-600'
                }`}>
                  <CubeTransparentIcon className="h-6 w-6" />
                </BentoIcon>
                <span className={`ml-3 font-semibold ${
                  isDarkMode ? 'text-green-300' : 'text-green-600'
                }`}>
                  Smarter Hiring
                </span>
              </div>
            }
            title="See the whole candidate, not just bullet points"
            description="Our profiles highlight transferable skills, real achievements, and actual capabilities—giving you a 360° view of candidates beyond what a traditional resume can express."
            className="sm:col-span-2 lg:col-span-1"
          />
        </div>
      </Container>
    </div>
  );
};

export default EmployerValuePropositionSection;
